import { atom } from "recoil";

export const scrollYState = atom({
  key: "scrollYState",
  default: 0,
});
